<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const store = useStore()
const router = useRouter()

const isHovering = ref(false)

const toggleProjectDialog = (payload) => store.dispatch('project/toggleProjectDialog', payload)
const toggleDeleteProjectDialog = (payload) =>
  store.dispatch('project/toggleDeleteProjectDialog', payload)

const navigateToProject = async (projectId) => {
  await router.push({ name: 'dikeIndex-trajectory', params: { id: projectId } })
}

const openDialog = async (type) => {
  if (type === 'duplicate') {
    // No action for duplicate
    return
  } else if (type === 'edit') {
    await toggleProjectDialog(props.item)
  } else if (type === 'delete') {
    await toggleDeleteProjectDialog(props.item)
  }
}
</script>

<template>
  <v-card
    class="d-flex flex-column fill-height"
    @click.stop="navigateToProject(item.id)"
    :elevation="isHovering ? 4 : 2"
    hover
    v-bind="props"
    @mouseout="isHovering = false"
    @mouseover="isHovering = true"
  >
    <v-card-subtitle class="pt-4">
      <span style="font-weight: 400; opacity: 1">{{ item['code'] }}</span>
    </v-card-subtitle>
    <v-card-title class="pt-1">
      <span>{{ item.name }}</span>
    </v-card-title>

    <div class="pl-4">
      <v-chip class="mr-3" label prepend-icon="mdi-map-marker" size="x-small" v-if="item?.location">
        {{ item.location }}
      </v-chip>
      <span style="color: rgba(0, 0, 0, 0.7); font-size: 14px; font-family: Roboto, sans-serif">
        {{ item.client }}
      </span>
    </div>
    <v-tooltip
      v-if="item.description"
      location="bottom"
      max-width="400px"
      style="overflow-wrap: break-word"
    >
      <template v-slot:activator="{ props }">
        <v-card-text class="elip pt-4 pb-2" v-bind="props">
          {{ item.description }}
        </v-card-text>
      </template>
      <span ref="element">{{ item.description }}</span>
    </v-tooltip>
    <v-card-text v-else class="elip pt-4 pb-2">-</v-card-text>
    <v-card-actions class="justify-end" style="background-color: #f6f6f6">
      <v-btn
        icon="mdi-pencil"
        @click.stop="openDialog('edit')"
        flat
        size="24"
        variant="text"
      ></v-btn>
      <div>
        <v-btn
          icon="mdi-delete-outline"
          @click.stop="openDialog('delete')"
          flat
          size="24"
          variant="text"
          class="ml-2"
        ></v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>
